import { render, staticRenderFns } from "./saleCategoryRepresntive.vue?vue&type=template&id=80833f04&"
import script from "./saleCategoryRepresntive.vue?vue&type=script&lang=js&"
export * from "./saleCategoryRepresntive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports